/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShockEventMotionStatus } from './ShockEventMotionStatus';
import {
    ShockEventMotionStatusFromJSON,
    ShockEventMotionStatusFromJSONTyped,
    ShockEventMotionStatusToJSON,
    ShockEventMotionStatusToJSONTyped,
} from './ShockEventMotionStatus';
import type { ShockEventLevel } from './ShockEventLevel';
import {
    ShockEventLevelFromJSON,
    ShockEventLevelFromJSONTyped,
    ShockEventLevelToJSON,
    ShockEventLevelToJSONTyped,
} from './ShockEventLevel';

/**
 * 
 * @export
 * @interface ShockEvent
 */
export interface ShockEvent {
    /**
     * 
     * @type {string}
     * @memberof ShockEvent
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShockEvent
     */
    shockProfileVersionId: string;
    /**
     * This is the time at which the shock has been reported to our system. Since shocks might happen in offline mode, `created_at` and `time` might differ considerably.
     * @type {Date}
     * @memberof ShockEvent
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShockEvent
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof ShockEvent
     */
    gForce: number;
    /**
     * 
     * @type {string}
     * @memberof ShockEvent
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShockEvent
     */
    vehicleId: string;
    /**
     * 
     * @type {ShockEventLevel}
     * @memberof ShockEvent
     */
    shockLevel: ShockEventLevel;
    /**
     * The period ID of the vehicle movement that was in progress when the event was detected.
     * @type {string}
     * @memberof ShockEvent
     */
    vehicleMovementPeriodId?: string | null;
    /**
     * 
     * @type {ShockEventMotionStatus}
     * @memberof ShockEvent
     */
    motionStatus: ShockEventMotionStatus;
    /**
     * The answer to the question: "Is the vehicle safe to drive after the medium impact shock?"
     * @type {boolean}
     * @memberof ShockEvent
     */
    mediumImpactSafe?: boolean | null;
}



/**
 * Check if a given object implements the ShockEvent interface.
 */
export function instanceOfShockEvent(value: object): value is ShockEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('shockProfileVersionId' in value) || value['shockProfileVersionId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('gForce' in value) || value['gForce'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('shockLevel' in value) || value['shockLevel'] === undefined) return false;
    if (!('motionStatus' in value) || value['motionStatus'] === undefined) return false;
    return true;
}

export function ShockEventFromJSON(json: any): ShockEvent {
    return ShockEventFromJSONTyped(json, false);
}

export function ShockEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shockProfileVersionId': json['shockProfileVersionId'],
        'createdAt': (new Date(json['createdAt'])),
        'time': (new Date(json['time'])),
        'gForce': json['gForce'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'vehicleId': json['vehicleId'],
        'shockLevel': ShockEventLevelFromJSON(json['shockLevel']),
        'vehicleMovementPeriodId': json['vehicleMovementPeriodId'] == null ? undefined : json['vehicleMovementPeriodId'],
        'motionStatus': ShockEventMotionStatusFromJSON(json['motionStatus']),
        'mediumImpactSafe': json['mediumImpactSafe'] == null ? undefined : json['mediumImpactSafe'],
    };
}

export function ShockEventToJSON(json: any): ShockEvent {
    return ShockEventToJSONTyped(json, false);
}

export function ShockEventToJSONTyped(value?: ShockEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shockProfileVersionId': value['shockProfileVersionId'],
        'createdAt': value['createdAt'].toISOString(),
        'time': value['time'].toISOString(),
        'gForce': value['gForce'],
        'userId': value['userId'],
        'vehicleId': value['vehicleId'],
        'shockLevel': ShockEventLevelToJSON(value['shockLevel']),
        'vehicleMovementPeriodId': value['vehicleMovementPeriodId'],
        'motionStatus': ShockEventMotionStatusToJSON(value['motionStatus']),
        'mediumImpactSafe': value['mediumImpactSafe'],
    };
}

